import { ApplicantDetailsROWResponse } from "@modules/application-section-row/application-details/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApplicationDetails, getReceiptDetails } from "../apiEndPoints";

export const fetchApplicationROWDetails = createAsyncThunk<
  ApplicantDetailsROWResponse,
  number
>("details/fetchApplicationROWDetails", async access_id => {
  try {
    const response = await getApplicationDetails({
      access_id 
    });
    return response.data.data;
  } catch (error: any) {
    return error
  }
});

export const fetchReceiptDetailsThunk = createAsyncThunk(
  "receipt-details",
  async (id: any, { rejectWithValue }) => {
    try {
      const response = await getReceiptDetails(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);